/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @format
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { Box, IconButton, Typography, } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import useStyles from './useStyles';

const Placeholder = () => {
  const { labelsData } = useSelector(state => state);
  const labels = labelsData?.labels;
  const classes = useStyles();
  return (
    <Box display={'flex'} alignItems={'center'} height={'100%'}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        borderRadius={'4px'}
        border={'1px dashed #ACACAC'}
        py={4}
        px={4}
        m={3}
      >
        <Typography variant='body1' className={classes.placeholderTitle}>{labels.DESIGNER_CREATE_LAYOUT}</Typography>
        <Typography variant='body1' className={classes.placeholderMsg}>
          {labels.DESIGNER_CLICK_ON}
          <IconButton className={classes.placeholderPlusIcon}>
            <Add />
          </IconButton>
          {labels.DESIGNER_ICON_TOP_LEFT}
        </Typography>
      </Box>
    </Box>
  );
};

export default Placeholder;
